import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { mmtc_sell_requestApi } from "../../app/slices/mmtc/mmtc_sell_requestSlice";
import { Box, IconButton, Tooltip } from "@mui/material";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";

import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";
import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";

export default function MmtcSellRequest() {

const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    name: "",
    metal: "",
 
    customerRefNo: "",
    metalType:"",
    quoteId:"",
    merchantTransactionId:""
  });

    const url = `/api/admin/mmtc-sell-req/list`
  
    const { handleFilterSubmit, handleClearFilters, loader, results, apiCall,message,error,toastTrigger } = useFilterHandler(url, filterData, setFilterData)

  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  // useEffect(() => {
  //   dispatch(mmtc_sell_requestApi(queryParams));
  // }, [dispatch, queryParams]);

  useEffect(() => {
    apiCall(false)
  }, []);

   useEffect(() => {
  if (!message) return;

  console.log("Message updated:", message);

  if (error) {
    toast.error(message);
  }

  // else {
  //   // toast.success(message);
  // }
}, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.mmtc_sell_request.mmtc_sell_request.data
  );
  const stateLoading = useSelector(
    (state) => state.mmtc_sell_request.loading
  );
  const columnHelper = createMRTColumnHelper();

  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id || "N/A");
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id || "N/A"}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),


    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerName", {
      header: "Name",
      size: 100,
      Cell: ({ cell }) => cell.row.original?.customerName ,
    }),

     columnHelper.accessor("phone", {
      header: "Phone",
      size: 100,
      Cell: ({ cell }) => cell.row.original?.phone ,
    }),
    // columnHelper.accessor("type", {
    //   header: "Type",
    //   size: 30,
    // }),
    // columnHelper.accessor("calculationType", {
    //   header: "Calculation Type",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.calculationType || "N/A",
    // }),
     columnHelper.accessor("metalType", {
      header: "metalType",
      size: 50,
    }),
  
    //  columnHelper.accessor("type", {
    //   header: "Type",
    //   size: 50,
    // }),

    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
    }),
   
    // columnHelper.accessor("quoteValidityTime", {
    //   header: "Quote Validity",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.quoteValidityTime || "N/A",
    // }),
    // columnHelper.accessor("taxType", {
    //   header: "Tax Type",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.taxType || "N/A",
    // }),
    // columnHelper.accessor("tax1Amt", {
    //   header: "Tax 1 Amount",
    //   size: 30,
    // }),
    // columnHelper.accessor("tax2Amt", {
    //   header: "Tax 2 Amount",
    //   size: 30,
    // }),
    // columnHelper.accessor("tax3Amt", {
    //   header: "Tax 3 Amount",
    //   size: 30,
    //   Cell: ({ cell }) => cell.row.original?.tax3Amt || "N/A",
    // }),
     columnHelper.accessor("metalRate", {
      header: "Metal Rate",
      size: 30,
      Cell: ({ cell }) => cell.row.original?.metalRate || "N/A",
    }),

    //   columnHelper.accessor("metalType", {
    //   header: "Metal Rate",
    //   size: 30,
    //   Cell: ({ cell }) => cell.row.original?.metalType || "N/A",
    // }),

    //  columnHelper.accessor("taxType", {
    //   header: "Tax Type",
    //   size: 30,
    // }),

    columnHelper.accessor("preTaxAmount", {
      header: "Pre-Tax Amount",
      size: 30,
    }),
    // columnHelper.accessor("taxAmount", {
    //   header: "Total Tax Amount",
    //   size: 30,
    //   Cell: ({ cell }) => cell.row.original?.taxAmount || "N/A",
    // }),
     columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
    }),
   
    // columnHelper.accessor("pricePerG", {
    //   header: "Price per Gram",
    //   size: 30,
    //   Cell: ({ cell }) => cell.row.original?.pricePerG || "N/A",
    // }),

    // columnHelper.accessor("orderId", {
    //   header: "Order ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.orderId);
    //       toast.success("Copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.orderId}>
    //         <>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.orderId}
    //         </>
    //       </Tooltip>
    //     );
    //   },
    // }),

    columnHelper.accessor("transactionRefNo", {
      header: "TransactionRefNo",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionRefNo}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionRefNo}
              </span>
            </>
          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("quoteId", {
      header: "QuoteId",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.quoteId);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.quoteId}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.quoteId}
              </span>
            </>
          </Tooltip>
        );
      },
    }),

    //  columnHelper.accessor("quoteValidityTime", {
    //   header: "Quote Validity Time",
    //   size: 30,
    // }),

    // columnHelper.accessor("transactionDate", {
    //   header: "Transaction Date",
    //   size: 50,
    //   Cell: ({ cell }) =>
    //     cell.row.original.transactionDate
    //       ? cell.row.original.transactionDate.split("T")[0]
    //       : "N/A",
    // }),
    // columnHelper.accessor("executionDateTime", {
    //   header: "Execution Date",
    //   size: 50,
    //   Cell: ({ cell }) =>
    //     cell.row.original.executionDateTime
    //       ? cell.row.original.executionDateTime.split("T")[0]
    //       : "N/A",
    // }),

    // columnHelper.accessor("netAmount", {
    //   header: "Net Amount",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.netAmount || "N/A",
    // }),
   
    // columnHelper.accessor("value", {
    //   header: "Amount",
    //   // header: "Value",
    //   size: 50,
    // }),
    // columnHelper.accessor("payOutPaymentChannel", {
    //   header: "Payout Channel",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.payOutPaymentChannel || "N/A",
    // }),
    // columnHelper.accessor("payOutCustomerName", {
    //   header: "Payout Customer Name",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.payOutCustomerName || "N/A",
    // }),
    // columnHelper.accessor("payOutAccountNumber", {
    //   header: "Payout Account Number",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.payOutAccountNumber || "N/A",
    // }),
    // columnHelper.accessor("payOutIFSC", {
    //   header: "Payout IFSC",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.payOutIFSC || "N/A",
    // }),
    // columnHelper.accessor("billingAddressId", {
    //   header: "Billing Address ID",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.billingAddressId || "N/A",
    // }),
    // columnHelper.accessor("invoiceId", {
    //   header: "Invoice ID",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.invoiceId || "N/A",
    // }),
    // columnHelper.accessor("addressLine1", {
    //   header: "Address Line 1",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.addressLine1 || "N/A",
    // }),
    // columnHelper.accessor("addressLine2", {
    //   header: "Address Line 2",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.addressLine2 || "N/A",
    // }),
    // columnHelper.accessor("city", {
    //   header: "City",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.city || "N/A",
    // }),
    // columnHelper.accessor("state", {
    //   header: "State",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.state || "N/A",
    // }),
    // columnHelper.accessor("zip", {
    //   header: "Zip Code",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.zip || "N/A",
    // }),
    // columnHelper.accessor("country", {
    //   header: "Country",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.country || "N/A",
    // }),
    // columnHelper.accessor("stateCode", {
    //   header: "State Code",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.stateCode || "N/A",
    // }),
    // columnHelper.accessor("addressType", {
    //   header: "Address Type",
    //   size: 50,
    //   Cell: ({ cell }) => cell.row.original?.addressType || "N/A",
    // }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 50,
      Cell: ({ cell }) => cell.row.original?.createdAt?.split("T")[0] || "N/A",
    }),
     columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 50,
      Cell: ({ cell }) => cell.row.original?.updatedAt?.split("T")[0] || "N/A",
    }),
  ];



  return (
    <>

     {/*  */}
      <Filter filterData={filterData} onFilterSubmit={handleFilterSubmit} Onclear={handleClearFilters} page={'mmtc_sell_req'} setFilterData={setFilterData} />
      

      {/* <DateSearchComponent onSearch={handleSearch} /> */}
      <Box mt={2}>
       {loader?<Loader/>:<CustomTable columns={columns} data={results} loading={loader} permissionKey="MMTCSellRequest"/>} 
      </Box>
    </>
  );
}
